import { Navigate } from 'react-router-dom';
import { getToken, isAuthenticated } from '../utils';

function ProtectedRoute({ children }) {
  const token = getToken().token;
  const isUserAuthenticated = isAuthenticated().status;

  if (!token || !isUserAuthenticated) {
    return <Navigate to='/SignIn' replace={true} />;
  }
  return children;
}

export default ProtectedRoute;
